import { useLazyQuery, useQuery } from "@apollo/client/react"; import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';

import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';
import { getRoundedNumber } from '../../../../utils/mathUtils';
import { CALCULAR_Z_SCORES } from '../../../../data/graphQL/queries/ResumenIngreso/calcularZScores';
import toast from 'react-hot-toast';

export const StepDatosGenerales3 = ({
  esAdulto,
  paciente,
  setDataSubmissionCallback,
  updateFormData,
  fullFormDataRI,
  pantallas,
  selectedPrograms,
  programOnlyCP
}) => {

  const [datosGenerales, setDatosGenerales] = useState(fullFormDataRI?.datosGenerales3 ?? {});
  const [combosRI, setCombosRI] = useState();

  const handleSubmit = () => {
    if (datosGenerales?.talla <= 0) {
      return toast.error('La talla debe ser mayor a 0.');
    }
    updateFormData(
      'datosGenerales3',
      datosGenerales,
      parsedInputsGroup.flatMap((x) => x.inputs)
    );
  };

  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);
  const [getCalculosZScores] = useLazyQuery(CALCULAR_Z_SCORES, {
    fetchPolicy: 'no-cache'
  });

  const valoresIdsFormulas = useMemo(() => {
    if (!combosRI) return {};

    const periodoMayorId = combosRI.idComboRIValorAduPerdidaPeso.find((x) => x.displayName.includes('Mayor')).id;
    const periodoMenorId = combosRI.idComboRIValorAduPerdidaPeso.find((x) => x.displayName.includes('Menor')).id;
    const gradoLeveId = combosRI.idComboRIValorAduGradoDesnutricion.find((x) => x.displayName.includes('Leve')).id;
    const gradoModeradoId = combosRI.idComboRIValorAduGradoDesnutricion.find((x) => x.displayName.includes('Moderado')).id;
    const gradoSeveraId = combosRI.idComboRIValorAduGradoDesnutricion.find((x) => x.displayName.includes('Severa')).id;

    return {
      periodoMayorId,
      periodoMenorId,
      gradoLeveId,
      gradoModeradoId,
      gradoSeveraId
    };
  }, [combosRI]);

  const parsedInputsGroup = useMemo(() => {
    const programasNoJustifican = ['CP', 'CD', 'KETO'];

    const idsProgramasNoJustifican = pantallas?.flatMap((p) => p.modulos?.
      filter((m) => programasNoJustifican.includes(m.displayName))?.
      map((m) => m.id) || []
    );

    const hasProgramaJustifica = selectedPrograms?.some((id) => !idsProgramasNoJustifican.includes(id));

    const filteredGroups = structuredClone(inputsGroups).filter((group) => !group[esAdulto ? 'esPed' : 'esAdulto']);

    if (!combosRI) return filteredGroups;

    return filteredGroups.map((group) => ({
      ...group,
      inputs: group.inputs.map((input) => {
        if (input.name === 'idComboRIValorNivelActividad') {
          input.required = !programOnlyCP;
          input.hidden = programOnlyCP;
        }

        if (!input.comboName) return input;

        if (input.name === 'justificacionSoporteRI') {
          input.hidden = !hasProgramaJustifica;
          input.required = !!hasProgramaJustifica;
        }

        if (input.name !== 'requerimientosExtraNutricionalesRI') {
          return {
            ...input,
            options: combosRI[input.name]
          };
        }

        const opcionNo = combosRI[input.name].find((x) => x.displayName.includes('NO'));

        const disableCondition = datosGenerales[input.name]?.includes(opcionNo?.id) ?
          (id) => id !== opcionNo?.id :
          (id) => datosGenerales[input.name]?.length ? id === opcionNo?.id : false;

        input.options = combosRI[input.name].map((com) => ({ ...com, disabled: disableCondition(com.id) }));
        return input;
      })
    }));
  }, [
    esAdulto,
    selectedPrograms,
    pantallas,
    datosGenerales.requerimientosExtraNutricionalesRI,
    combosRI]
  );

  const comboDiagnosticoNutricional = useMemo(() => {
    //Calculo, auto seleccionamiento y filtrado de opciones diágnostico nutricional para paciente adulto
    if (!esAdulto || !combosRI) return;
    const { gradoLeveId, gradoModeradoId, gradoSeveraId } = valoresIdsFormulas;

    switch (datosGenerales.idComboRIValorAduGradoDesnutricion) {
      case gradoLeveId:
        setDatosGenerales((prevDatos) => ({
          ...prevDatos,
          idComboRIValorAduDiagnosticoNutricional: null
        }));
        return combosRI.idComboRIValorAduDiagnosticoNutricional.
          filter((x) => x.displayName.includes('Normonutrido') || x.displayName.includes('Riesgo nutricional'));
      case gradoModeradoId:
        const comboValorModerada = combosRI.idComboRIValorAduDiagnosticoNutricional.
          filter((x) => x.displayName.includes('Desnutrición Moderada'));
        setDatosGenerales((prevDatos) => ({ ...prevDatos, idComboRIValorAduDiagnosticoNutricional: comboValorModerada[0].id }));
        return comboValorModerada;
      case gradoSeveraId:
        const comboValorSevera = combosRI.idComboRIValorAduDiagnosticoNutricional.
          filter((x) => x.displayName.includes('Desnutrición Severa'));
        setDatosGenerales((prevDatos) => ({ ...prevDatos, idComboRIValorAduDiagnosticoNutricional: comboValorSevera[0].id }));
        return comboValorSevera;
      default:
        return [];
    }

  }, [
    combosRI,
    esAdulto,
    datosGenerales.idComboRIValorAduGradoDesnutricion,
    fullFormDataRI?.datosGenerales3?.idComboRIValorAduDiagnosticoNutricional]
  );


  useEffect(() => {
    //Calculo de IMC y % pérdida de peso para paciente adulto
    if (!esAdulto) return;
    const calcularImc = (pesoActual, talla) =>
      getRoundedNumber(pesoActual / (talla * talla)) || 0;


    const calcularPerdidaPeso = (pesoHabitual, pesoActual) =>
      getRoundedNumber((pesoHabitual - pesoActual) / pesoHabitual * 100) || 0;


    setDatosGenerales((prevDatos) => ({
      ...prevDatos,
      aduIMC: calcularImc(prevDatos.pesoActual, prevDatos.talla),
      aduPerdidaPeso: calcularPerdidaPeso(prevDatos.aduPesoHabitual, prevDatos.pesoActual)
    }));
  }, [
    esAdulto,
    datosGenerales.pesoActual,
    datosGenerales.talla,
    datosGenerales.aduPesoHabitual]
  );

  useEffect(() => {
    //Calculo de grado de desnutrición para paciente adulto
    if (!esAdulto) return;
    setDatosGenerales((prevDatos) => {
      const { aduPerdidaPeso, idComboRIValorAduPerdidaPeso: periodo } = prevDatos;
      const { periodoMayorId, periodoMenorId, gradoLeveId, gradoModeradoId, gradoSeveraId } = valoresIdsFormulas;

      let idComboRIValorAduGradoDesnutricion;
      if (aduPerdidaPeso === null || aduPerdidaPeso === undefined || !periodo) {
        idComboRIValorAduGradoDesnutricion = null;
      } else
        if (aduPerdidaPeso < 5 && periodo === periodoMenorId || aduPerdidaPeso < 10 && periodo === periodoMayorId) {
          idComboRIValorAduGradoDesnutricion = gradoLeveId;
        } else
          if (aduPerdidaPeso >= 5 && aduPerdidaPeso <= 10 && periodo === periodoMenorId || aduPerdidaPeso >= 10 && aduPerdidaPeso <= 20 && periodo === periodoMayorId) {
            idComboRIValorAduGradoDesnutricion = gradoModeradoId;
          } else
            if (aduPerdidaPeso > 10 && periodo === periodoMenorId || aduPerdidaPeso > 20 && periodo === periodoMayorId) {
              idComboRIValorAduGradoDesnutricion = gradoSeveraId;
            }
      return { ...prevDatos, idComboRIValorAduGradoDesnutricion };
    });
  }, [
    esAdulto,
    datosGenerales.aduPerdidaPeso,
    datosGenerales.idComboRIValorAduPerdidaPeso,
    valoresIdsFormulas]
  );

  useEffect(() => {
    //Calculo y auto seleccionamiento de Meta del soporte nutricional - adulto
    if (!esAdulto || !combosRI) return;
    setDatosGenerales((prevDatos) => {
      const replecionId = combosRI.idComboRIValorAduMetaNutricional.find((x) => x.displayName.includes('Repleción')).id;
      const mantenimientoId = combosRI.idComboRIValorAduMetaNutricional.find((x) => x.displayName.includes('Mantenimiento')).id;

      const diagnosticoSeveraId = combosRI.idComboRIValorAduDiagnosticoNutricional.find((x) => x.displayName.includes('Desnutrición Severa')).id;
      const diagnosticoModeradaId = combosRI.idComboRIValorAduDiagnosticoNutricional.find((x) => x.displayName.includes('Desnutrición Moderada')).id;
      const diagnosticoRiesgoNutriId = combosRI.idComboRIValorAduDiagnosticoNutricional.find((x) => x.displayName.includes('Riesgo nutricional')).id;
      const diagnosticoNormunutridoId = combosRI.idComboRIValorAduDiagnosticoNutricional.find((x) => x.displayName.includes('Normonutrido')).id;

      let idComboRIValorAduMetaNutricional = null;

      if (datosGenerales.idComboRIValorAduDiagnosticoNutricional === diagnosticoSeveraId ||
        datosGenerales.idComboRIValorAduDiagnosticoNutricional === diagnosticoModeradaId)
        idComboRIValorAduMetaNutricional = replecionId; else

        if (datosGenerales.idComboRIValorAduDiagnosticoNutricional === diagnosticoRiesgoNutriId ||
          datosGenerales.idComboRIValorAduDiagnosticoNutricional === diagnosticoNormunutridoId && esAdulto)
          idComboRIValorAduMetaNutricional = mantenimientoId;

      return { ...prevDatos, idComboRIValorAduMetaNutricional };

    });

  }, [
    esAdulto,
    combosRI,
    datosGenerales.idComboRIValorAduDiagnosticoNutricional]
  );

  useEffect(() => {
    //Calculo de Z Scores para pediátricos
    if (esAdulto || !datosGenerales.talla || !datosGenerales.pesoActual) return;
    const { edad, meses, dia, sexo } = paciente;
    const getCalculos = async () => {

      const { data } = await getCalculosZScores({
        variables: {
          tallaEnMetros: datosGenerales.talla,
          peso: datosGenerales.pesoActual,
          edad,
          mes: meses,
          dia: dia,
          sexo
        }
      });

      if (!data) return;

      const { calcularZScores: { zTalla, zPeso, zIMC } } = data;
      setDatosGenerales((prevDatos) => ({
        ...prevDatos,
        pedZScoreTalla: zTalla,
        pedZScorePeso: zPeso,
        pedZScoreIMC: zIMC
      }));
    };
    getCalculos();

  }, [
    esAdulto,
    datosGenerales.pesoActual,
    datosGenerales.talla,
    paciente]
  );

  useEffect(() => {
    //Cálculo y auto selección de Diagnostico Nutricional por ind. Antropométrico para pediátricos
    if (
      esAdulto ||
      !combosRI?.idComboRIValorPedDiagnosticoNutricional ||
      !combosRI?.idComboRIValorPedMetaSoporteNutricional ||
      isNaN(datosGenerales.pedZScoreIMC))
      return;

    const diagnosticos = combosRI.idComboRIValorPedDiagnosticoNutricional;
    const metaSoporte = combosRI.idComboRIValorPedMetaSoporteNutricional;

    const crecimientoId = metaSoporte.find((x) => x.displayName.includes('Crecimiento'))?.id;
    const replecionId = metaSoporte.find((x) => x.displayName.includes('Repleción'))?.id;

    const normalId = diagnosticos.find((x) => x.displayName.includes('Normal'))?.id;
    const sobrepesoId = diagnosticos.find((x) => x.displayName.includes('Sobrepeso'))?.id;
    const obesidadId = diagnosticos.find((x) => x.displayName.includes('Obesidad'))?.id;
    const desnutricionLeveId = diagnosticos.find((x) => x.displayName.includes('Desnutrición leve'))?.id;
    const desnutricionModeradaId = diagnosticos.find((x) => x.displayName.includes('Desnutrición Moderada'))?.id;
    const desnutricionGraveId = diagnosticos.find((x) => x.displayName.includes('Desnutrición Grave'))?.id;

    const reglasDiagnostico = [
      { id: normalId, meta: crecimientoId, condition: (zimc, edad) => edad >= 0 && edad <= 5 && -1 <= zimc && zimc <= 2 || edad > 5 && edad <= 15 && -1 < zimc && zimc < 1 },
      { id: sobrepesoId, meta: crecimientoId, condition: (zimc, edad) => edad >= 0 && edad <= 5 && 2 < zimc && zimc <= 3 || edad > 5 && edad <= 15 && 1 <= zimc && zimc <= 2 },
      { id: obesidadId, meta: crecimientoId, condition: (zimc, edad) => edad >= 0 && edad <= 5 && zimc > 3 || edad > 5 && edad <= 15 && zimc > 2 },
      { id: desnutricionLeveId, meta: replecionId, condition: (zimc) => -2 <= zimc && zimc < -1 },
      { id: desnutricionModeradaId, meta: replecionId, condition: (zimc) => -3 <= zimc && zimc < -2 },
      { id: desnutricionGraveId, meta: replecionId, condition: (zimc) => zimc < -3 }];


    const selectDiagnostico = (zimc, edad) => {
      const regla = reglasDiagnostico.find((r) => r.condition(zimc, edad));
      return regla ? [regla.id, regla.meta] : null;
    };
    const [diagnosticoId, metaSoporteId] = selectDiagnostico(datosGenerales.pedZScoreIMC, paciente.edad);

    setDatosGenerales((prevDatos) => ({
      ...prevDatos,
      idComboRIValorPedDiagnosticoNutricional: diagnosticoId,
      idComboRIValorPedMetaSoporteNutricional: metaSoporteId
    }));

  }, [
    esAdulto,
    combosRI?.idComboRIValorPedDiagnosticoNutricional,
    combosRI?.idComboRIValorPedMetaSoporteNutricional,
    datosGenerales.pedZScoreIMC,
    paciente]
  );

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [datosGenerales, setDataSubmissionCallback, parsedInputsGroup]);



  const handleChange = (name, value) => {
    setDatosGenerales((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  return (
    <div>
      {parsedInputsGroup.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          <label className='step-form-section-title'>{group.groupName}</label>
          <Grid container>
            {group.inputs.
              filter((i) => !i.hidden).
              map((input) => {
                return (
                  <RenderInputByTypeMobile
                    key={`${group.groupName}-${input.name}-${input.type === 'select' ? datosGenerales[input.name] : ''}`}
                    grided
                    handleChange={handleChange}
                    input={input.name === 'idComboRIValorAduDiagnosticoNutricional' ? {
                      ...input,
                      options: comboDiagnosticoNutricional
                    } : input}
                    value={datosGenerales[input.name]} />);


              })}
          </Grid>
        </div>
      )}
    </div>);

};

const inputsGroups = [
  {
    groupName: 'Parámetros antropométricos',
    inputs: [
      {
        name: 'pesoActual',
        displayName: 'Peso actual(Kg)',
        type: 'float',
        required: true,
        min: 1
      },
      {
        name: 'talla',
        displayName: 'Talla (m)',
        type: 'float',
        required: true,
        min: 0
      },
      {
        name: 'idComboRIValorNivelActividad',
        displayName: 'Nivel de actividad',
        comboName: 'Nivel de actividad',
        type: 'select',
        options: [],
        required: true
      }]

  },
  {
    groupName: 'Paciente Adulto',
    esAdulto: true,
    inputs: [
      {
        name: 'idComboRIValorAduPerdidaPeso',
        comboName: 'Tiempo',
        displayName: 'Período de perdida de peso',
        type: 'select',
        required: true
      }, {
        name: 'aduPesoHabitual',
        displayName: 'Peso habitual (kg)',
        type: 'float',
        required: true
      },
      {
        name: 'idComboRIValorAduEvaluado',
        displayName: 'Evaluado',
        comboName: 'Evaluado',
        type: 'select',
        options: [],
        required: true
      },
      {
        name: 'aduIMC',
        displayName: 'IMC',
        type: 'string',
        disabled: true
      },
      {
        name: 'aduPerdidaPeso',
        displayName: '% Pérdida de peso',
        type: 'string',
        disabled: true
      },
      {
        name: 'idComboRIValorAduGradoDesnutricion',
        comboName: 'GradoDesnutricion',
        displayName: 'Grado de desnutrición',
        type: 'select',
        required: true,
        disabled: true
      },
      {
        name: 'idComboRIValorAduDiagnosticoNutricional',
        displayName: 'Diagnóstico nutricional',
        comboName: 'Diagnóstico nutricional',
        type: 'select',
        required: true,
        disabled: false
      },
      {
        name: 'idComboRIValorAduMetaNutricional',
        displayName: 'Meta del soporte nutricional',
        comboName: 'Meta del soporte nutricional',
        type: 'select',
        disabled: true
      }]

  },
  {
    groupName: 'Datos clínicos pediátricos',
    esPed: true,
    inputs: [
      {
        name: 'pedCircunferenciaMBraquial',
        displayName: 'Circunferencia media braquial (Cm)',
        type: 'float'
      },
      {
        name: 'pedZScoreTalla',
        displayName: 'Z Score Talla',
        type: 'float',
        disabled: true
      },
      {
        name: 'pedZScorePeso',
        displayName: 'Z Score Peso',
        type: 'float',
        disabled: true
      },
      {
        name: 'pedZScoreIMC',
        displayName: 'Z Score IMC',
        type: 'float',
        disabled: true
      },
      {
        name: 'idComboRIValorPedDiagnosticoNutricional',
        displayName: 'Diagnóstico nutricional por ind. Antropométricos',
        comboName: 'Diagnóstico nutricional por ind. Antropométricos',
        type: 'select',
        disabled: true
      },
      {
        name: 'idComboRIValorPedMetaSoporteNutricional',
        displayName: 'Meta del soporte nutricional',
        comboName: 'Meta del soporte nutricional',
        type: 'select',
        disabled: true
      }]

  },
  {
    groupName: '',
    inputs: [
      {
        name: 'justificacionSoporteRI',
        displayName: 'Justificación de soporte',
        comboName: 'Justificación de soporte',
        type: 'multiple_select',
        options: [],
        required: false
      },
      {
        name: 'requerimientosExtraNutricionalesRI',
        displayName: 'Requerimientos extra nutricionales',
        comboName: 'Requerimientos extranutricionales',
        type: 'multiple_select',
        options: [],
        required: true
      }]

  }];